import { useEffect } from 'react';
import { useStateInRef } from '../../../../utils/useStateInRef';
export function useSheetRunPageLifecycle(param) {
    let { entries, openEntries, triggerClose, onModalExited } = param;
    function reportPageLeft(entry, param) {
        let { theSheetIsClosing } = param;
        var _entry_sheetPage_onRemoved, _entry_sheetPage, _entry_sheetPage_onClose, _entry_sheetPage1;
        if (entry.settled) return;
        entry.settled = true;
        (_entry_sheetPage = entry.sheetPage) === null || _entry_sheetPage === void 0 ? void 0 : (_entry_sheetPage_onRemoved = _entry_sheetPage.onRemoved) === null || _entry_sheetPage_onRemoved === void 0 ? void 0 : _entry_sheetPage_onRemoved.call(_entry_sheetPage);
        if (theSheetIsClosing) (_entry_sheetPage1 = entry.sheetPage) === null || _entry_sheetPage1 === void 0 ? void 0 : (_entry_sheetPage_onClose = _entry_sheetPage1.onClose) === null || _entry_sheetPage_onClose === void 0 ? void 0 : _entry_sheetPage_onClose.call(_entry_sheetPage1);
        entry.resolve(undefined);
        onModalExited(entry.id);
    }
    function settleEveryPageOnceTheDrawerHasSlidOut() {
        entries.forEach((entry)=>reportPageLeft(entry, {
                theSheetIsClosing: true
            }));
    }
    function settlePagesPoppedOffAStillOpenDrawer() {
        entries.filter((entry)=>!entry.isOpen).forEach((entry)=>reportPageLeft(entry, {
                theSheetIsClosing: false
            }));
    }
    const getUnmountSettlement = useStateInRef(settleEveryPageOnceTheDrawerHasSlidOut);
    const drawerIsStillOpen = openEntries.length > 0;
    useEffect(()=>{
        if (drawerIsStillOpen) settlePagesPoppedOffAStillOpenDrawer();
    });
    useEffect(()=>{
        return ()=>getUnmountSettlement()();
    }, [
        getUnmountSettlement
    ]);
    return {
        dismissPage: (entry)=>()=>triggerClose(entry.id),
        dismissEveryPage: ()=>[
                ...openEntries
            ].reverse().forEach((entry)=>triggerClose(entry.id)),
        settleEveryPageOnceTheDrawerHasSlidOut
    };
}
